var adengine = function() {
  if (typeof window !== "undefined") {
    return require("./adengine");
  } else {
    return null;
  }
};
module.exports = adengine();
